import { Box } from '@mui/material';
import { BoxProps } from '@mui/material/Box/Box';
import classNames from 'classnames';

import { useSxStyles } from './useStyles';

export const ChipList = (
  props: BoxProps & {
    variant?: 'highlighted' | 'outlined';
    error?: boolean;
  },
) => {
  const sxStyles = useSxStyles();
  const { sx, children, variant, error, ...boxProps } = props;
  const sxBox = { ...sxStyles.chipList, ...sx };

  return (
    <Box
      sx={sxBox}
      {...boxProps}
      className={classNames(variant, error && 'error')}
    >
      {children}
    </Box>
  );
};
